/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MoneyCurrencyRubleIcon16Light } from './MoneyCurrencyRubleIcon16Light';
import { MoneyCurrencyRubleIcon16Regular } from './MoneyCurrencyRubleIcon16Regular';
import { MoneyCurrencyRubleIcon16Solid } from './MoneyCurrencyRubleIcon16Solid';
import { MoneyCurrencyRubleIcon20Light } from './MoneyCurrencyRubleIcon20Light';
import { MoneyCurrencyRubleIcon20Regular } from './MoneyCurrencyRubleIcon20Regular';
import { MoneyCurrencyRubleIcon20Solid } from './MoneyCurrencyRubleIcon20Solid';
import { MoneyCurrencyRubleIcon24Regular } from './MoneyCurrencyRubleIcon24Regular';
import { MoneyCurrencyRubleIcon24Solid } from './MoneyCurrencyRubleIcon24Solid';
import { MoneyCurrencyRubleIcon32Regular } from './MoneyCurrencyRubleIcon32Regular';
import { MoneyCurrencyRubleIcon64Regular } from './MoneyCurrencyRubleIcon64Regular';
var sizes = {
    16: {
        light: MoneyCurrencyRubleIcon16Light,
        regular: MoneyCurrencyRubleIcon16Regular,
        solid: MoneyCurrencyRubleIcon16Solid,
    },
    20: {
        light: MoneyCurrencyRubleIcon20Light,
        regular: MoneyCurrencyRubleIcon20Regular,
        solid: MoneyCurrencyRubleIcon20Solid,
    },
    24: {
        regular: MoneyCurrencyRubleIcon24Regular,
        solid: MoneyCurrencyRubleIcon24Solid,
    },
    32: {
        regular: MoneyCurrencyRubleIcon32Regular,
    },
    64: {
        regular: MoneyCurrencyRubleIcon64Regular,
    },
};
export var MoneyCurrencyRubleIcon = forwardRef('MoneyCurrencyRubleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
